import $ from '@ali/tarzan-zepto';
// import moment from 'moment';
import BaseUI from '../../../component/baseui/index';
import tpl from './tpl.html';
import util from '../../../lib/util.js';

import './style.scss';

const clickType = util.isPC() ? 'click' : 'tap';

export default function express(data) {
  data.status_current = null;
  data.status.map((item, index) => {
    if (item.active) {
      item.className = 'current';
      data.status_current = index;
    }
    return item;
  });
  data.status.map((item, index) => {
    if (index < data.status_current) {
      item.className = '';
    } else if (index > data.status_current) {
      item.className = 'un';
    }
    return item;
  });

  data.shipping = this.util.lang.get('SHIPPING:ADDRESS');
  data.tracking = this.util.lang.get('tracking')(data.index, data.number);
  const param = {
    name: 'express',
    content: tpl.render(data),
  };
  const action = data.action || {
    source: 'event',
    intentId: data.commentId,
  };
  const $node = $(BaseUI.msg(param));

  $node.find('a').on(clickType, (ev) => {
    ev.preventDefault();
    const $target = $(ev.target);
    const link = document.createElement('a');
    link.href = $target.attr('href');
    link.target = '_blank';
    link.click();
    $(link).remove();
  });

  this.view.body.scrollToBottom();
  this.view.footer.submit({ q: 'feedback', ext: { botJson: JSON.stringify(action) } }, 'text', false, true);
  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/express/index.js